import types from '../types'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

const serverURL = getApiServer()

export const getUser = () => async (dispatch) => {
  dispatch({ type: types.GET_USER_REQUESTED })
  try {
    const user = await axios.get(serverURL + '/api/user', { withCredentials: true })
    dispatch({ type: types.GET_USER_FULFILLED, payload: user.data })
  } catch (error) {
    dispatch({ type: types.GET_USER_REJECTED, payload: error.response.data })
  }
}

export const loginUser = (credentials) => async (dispatch) => {
  dispatch({ type: types.LOGIN_USER_REQUESTED })
  try {
    const user = await axios.post(serverURL + '/api/login', credentials, { withCredentials: true })
    dispatch({ type: types.LOGIN_USER_FULFILLED, payload: user.data })
  } catch (error) {
    dispatch({ type: types.LOGIN_USER_REJECTED, payload: error.response.data })
  }
}

export const logoutUser = (userId) => async (dispatch) => {
  dispatch({ type: types.LOGOUT_USER_REQUESTED })
  try {
    await axios.post(serverURL + '/api/logout', { userId }, { withCredentials: true })
    dispatch({ type: types.LOGOUT_USER_FULFILLED })
  } catch (error) {
    dispatch({ type: types.LOGOUT_USER_REJECTED, payload: error.response.data })
  }
}

export const forgotPasswordUser = (email) => async (dispatch) => {
  dispatch({ type: types.FORGOT_PASSWORD_USER_REQUESTED })
  try {
    const user = await axios.post(serverURL + '/api/forgot-password', email)
    dispatch({ type: types.FORGOT_PASSWORD_USER_FULFILLED, payload: user?.data })
  } catch (error) {
    dispatch({ type: types.FORGOT_PASSWORD_USER_REJECTED, payload: error?.response?.data })
  }
}

export const changePasswordUser = (values) => async (dispatch) => {
  dispatch({ type: types.CHANGE_PASSWORD_USER_REQUESTED })
  try {
    const user = await axios.post(serverURL + '/api/change-password', values)
    dispatch({ type: types.CHANGE_PASSWORD_USER_FULFILLED, payload: user?.data })
  } catch (error) {
    dispatch({ type: types.CHANGE_PASSWORD_USER_REJECTED, payload: error?.response?.data })
  }
}

export const verifyUser = (user) => async (dispatch) => {
  dispatch({ type: types.VERIFY_USER_REQUESTED })
  try {
    const verifiedUser = await axios.post(serverURL + '/api/verify', { user })
    dispatch({ type: types.VERIFY_USER_FULFILLED, payload: verifiedUser.data })
  } catch (error) {
    dispatch({ type: types.VERIFY_USER_REJECTED, payload: error.response.data })
  }
}

export const verifyToken = (token) => async (dispatch) => {
  dispatch({ type: types.VERIFY_TOKEN_USER_REQUESTED })
  try {
    const verifiedToken = await axios.post(serverURL + '/api/verify-token', { token })
    dispatch({ type: types.VERIFY_TOKEN_USER_FULFILLED, payload: verifiedToken.data })
  } catch (error) {
    dispatch({ type: types.VERIFY_TOKEN_USER_REJECTED, payload: error.response.data })
  }
}

export const validateUser = (user, code) => async (dispatch) => {
  dispatch({ type: types.VALIDATE_USER_REQUESTED })
  try {
    const validatedUser = await axios.post(serverURL + '/api/validate', { user, code }, { withCredentials: true })
    dispatch({ type: types.VALIDATE_USER_FULFILLED, payload: validatedUser.data })
  } catch (error) {
    dispatch({ type: types.VALIDATE_USER_REJECTED, payload: error.response.data })
  }
}

export const resendCode = (userId) => async (dispatch) => {
  dispatch({ type: types.RESEND_CODE_REQUESTED })
  try {
    await axios.post(serverURL + '/api/code', { userId })
    dispatch({ type: types.RESEND_CODE_FULFILLED })
  } catch (error) {
    dispatch({ type: types.RESEND_CODE_REJECTED, payload: error.response.data })
  }
}

export const resetUserState = () => (dispatch) => {
  dispatch({ type: types.RESET_USER_STATE })
}